import script from "./GoldSeal.vue?vue&type=script&setup=true&lang=js"
export * from "./GoldSeal.vue?vue&type=script&setup=true&lang=js"

import "./GoldSeal.vue?vue&type=style&index=0&id=3c8fd5ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c8fd5ed"]])

export default __exports__